// we have to use these constants due to eslint and prettier not liking camelCase
const THUMB_DOWN_ALT = 'thumb_down_alt';
const THUMB_UP_ALT = 'thumb_up_alt';

export const ICON_OPTION_LABELS = {
  [THUMB_DOWN_ALT]: 'Mark this information as not helpful',
  [THUMB_UP_ALT]: 'Mark this information as helpful',
};

export const getIconOptionLabel = icon => {
  if (!icon) {
    return '';
  }

  return ICON_OPTION_LABELS[icon] || icon.replace(/_/g, ' ');
};
